import React from 'react';
import {Table} from '../../../components/table/Table';
import {MailContentRender} from '../components/ExpandableRowComponent';
import {useInvoke} from '../../../controllers/useInvoke';
import {useTheme} from '@unthinkable/react-theme';
import {Text, View} from '@unthinkable/react-core-components';

const EMAIL_SEQUENCE = {
  field: 'drip_sequence',
  header: 'Sequence',
  width: 150,
};

const EMAIL_SUBJECT = {
  field: 'email_subject',
  header: 'Subject',
  responsive: 'sm',
};

const NAME = {
  field: 'name',
  header: 'Name',
  responsive: 'sm',
};

const CREATEDON = {
  type: 'date',
  field: 'created_on',
  header: 'Created On',
};

const COMPLETEDON = {
  type: 'date',
  field: 'completed_date',
  header: 'Completed Date',
};

const RenderType = props => {
  const {
    row,
    styles: {rowText},
  } = props;
  const colors = useTheme('colors');
  if (!row?.type) return null;
  let backgroundColors;
  if (row?.type == 'Message Series') {
    backgroundColors = colors['ACCENT5_MEDIUM'];
  } else if (row?.type == 'Connection Message') {
    backgroundColors = colors['ACCENT6_MEDIUM'];
  }
  return (
    <Text
      style={{
        ...rowText,
        width: 150,
        backgroundColor: backgroundColors,
        padding: 2,
        borderRadius: 5,
        textAlign: 'center',
      }}>
      {row?.type}
    </Text>
  );
};

const ViewBody = ({styles}) => {
  const colors = useTheme('colors');
  return (
    <View style={{justifyContent: 'center', alignItems: 'center'}}>
      <Text style={{...styles.rowText, color: colors?.['ACCENT1_HIGH']}}>
        View Body
      </Text>
    </View>
  );
};


export const DripEmailActiveTable = props => {
  const {
    route: {params},
    navigation,
    searchValue,
  } = props;
  const {communicationFilter, marketingThemeFilter} = params;
  const invoke = useInvoke({
    method: 'put',
    eventSourceId: 'dripEmailAdded',
  });
  return (
    <Table
      search={searchValue}
      searchFields={'subject'}
      eventSourceId="dripEmailAdded"
      api={`/drip-emails-with-response-rate`}
      addOnFilter={{
        status: 'active',
        ...communicationFilter,
        ...marketingThemeFilter,
      }}
      params={params}
      renderExpandRow={({row}) => {
        return (
          <MailContentRender
            subject={row.email_subject}
            message={row?.email_body}
          />
        );
      }}
      columns={[
        NAME,
        {
          width: 200,
          header: 'Response Rate',
          field: 'response',
          type: 'number',
          formatOptions: {
            maximumFractionDigits: 2,
          },
        },
        {
          render: ViewBody,
          expandable: true,
          responsive: 'sm',
          width: 150,
        },
      ]}
      moreActions={[
        {
          title: 'Edit',
          onPress: row => {
            navigation.navigate('edit-drip-email', row);
          },
        },
        // {
        //   title: 'Mark Completed',
        //   onPress: markComplete,
        // },
      ]}
    />
  );
};

export const DripEmailCompletedTable = ({route: {params}, searchValue}) => {
  const {communicationFilter} = params;
  return (
    <Table
      search={searchValue}
      searchFields={['email_subject', 'name']}
      api={`/drip-emails-with-response-rate`}
      addOnFilter={{
        status: 'completed',
        ...communicationFilter,
      }}
      params={params}
      columns={[
        EMAIL_SEQUENCE,
        EMAIL_SUBJECT,
        {
          width: 200,
          header: 'Type',
          render: RenderType,
          align: 'center',
        },
        {
          width: 200,
          header: 'Response Rate',
          field: 'response',
          type: 'number',
          formatOptions: {
            maximumFractionDigits: 2,
          },
        },
        CREATEDON,
        COMPLETEDON,
      ]}
    />
  );
};
